export class SerieEstadistica {

    ajusteEstacional!:string;
    base!:string;
    categoria!:string;
    categoriaNivel1!:string;
    categoriaNivel2!:string;
    categoriaNivel3!:string;
    descripcion!:string;
    descripcionCorta!:string;
    descripcionPeriodicidad!:string;
    fechaFinal!:string;
    fechaInicial!:string;
    fechaUltimoCargue!:string;
    fichaTecnica: Array<string> = new Array();
    fuente!:string;
    geografia!:string;
    id!:number;
    idPeriodicidad!:number;
    idPlan!:string;
    isSerie!:string;
    nombre!:string;
    notas!:string;
    numeroDecimales!:number;
    periodoReferencia!:string;
    precio!:string;
    subcategoria!:string;
    tieneHijos!:string;
    unidad!:string;
    unidadCorta!:string;
    valor!:number;
    feErratas!:string;
    definicion!:string;

    fecha!: string;
    idTipoDato!: number;
    descripcionTipoDato!: string;
    fechaProximoCargue!: string;
    idCategoria!: number;
    fechaPublicacionDato!: string;
    descripcionSubCategoria!: string;
    
    baseSerie!: string;
    desestacionalizacion!: string;
    fuenteCorta!: string;
    precioSerie!: string;
    valorAtributo!: string;
    padreSerieDescripcion!: string;

    tipoVisualizacion:string ='line';

    data!:[];

    //EXTRA
    tipoVisualizacionNota:string='';

    metadataNotas:any;
}
